import { getResource } from "./request";

export async function getAllFunds() {
  const endpoint = "fund/GetFunds";
  const { response, error, code } = await getResource({ endpoint });
  return { response, error, code };
}

export async function getSingleFund(data: SingleFundFormType) {
  const { response, error, code } = await getResource({
    endpoint: "fund/GetFund",
    data,
  });
  return { response, error, code };
}

export interface FundQuickStatsType {
  total_proposals: number;
  fund_budget: number;
  amount_requested: number;
  funded_proposals: number;
  funded_amount: number;
}

export interface FundsCardType {
  fund_id: number;
  fund_name: string;
  start_date: string;
  launched_date: string;
  launched_month: string;
  start_month: string;
  quick_stats_data: FundQuickStatsType;
}

export interface SingleFundFormType {
  fund_id: number;
}

export interface FundCardType {
  fund_id: number;
  fund_name: string;
  start_date: string;
  launched_date: string;
  quick_stats_data: FundQuickStatsType;
}

export interface FundQuickStatsType {
  total_proposals: number;
  fund_budget: number;
  amount_requested: number;
  funded_proposals: number;
  funded_amount: number;
}
